import type React from 'react'

import { SkeletonTable } from '@/components/framework'

interface DashboardBookingsTableSkeletonProps {
  columns: number
}

export const DashboardBookingsTableSkeleton: React.FC<DashboardBookingsTableSkeletonProps> = ({
  columns,
}) => (
  <div
    aria-label="dashboard-bookings-table-skeleton"
    className="rounded border border-gray-200 p-2"
  >
    <SkeletonTable columns={columns} rows={6} />
  </div>
)
